import { render } from "./organisations.vue?vue&type=template&id=5f225c1c&ts=true"
import script from "./organisations.vue?vue&type=script&lang=ts"
export * from "./organisations.vue?vue&type=script&lang=ts"

import "./organisations.vue?vue&type=style&index=0&id=5f225c1c&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__